export const PUSH_PLUS_BUTTON_REQUEST = "PUSH_PLUS_BUTTON_REQUEST";
export const PUSH_PLUS_BUTTON_SUCCESS = "PUSH_PLUS_BUTTON_SUCCESS";
export const PUSH_MINUS_BUTTON_REQUEST = "PUSH_MINUS_BUTTON_REQUEST";
export const PUSH_MINUS_BUTTON_SUCCESS = "PUSH_MINUS_BUTTON_SUCCESS";
export const PUSH_MULTIPLY_BUTTON_REQUEST = "PUSH_MULTIPLY_BUTTON_REQUEST";
export const PUSH_MULTIPLY_BUTTON_SUCCESS = "PUSH_MULTIPLY_BUTTON_SUCCESS";
export const PUSH_DIVIDE_BUTTON_REQUEST = "PUSH_DIVIDE_BUTTON_REQUEST";
export const PUSH_DIVIDE_BUTTON_SUCCESS = "PUSH_DIVIDE_BUTTON_SUCCESS";
export const PUSH_NUMBER_BUTTON_REQUEST = "PUSH_NUMBER_BUTTON_REQUEST";
export const PUSH_NUMBER_BUTTON_SUCCESS = "PUSH_NUMBER_BUTTON_SUCCESS";
export const PUSH_EQUAL_REQUEST = "PUSH_EQUAL_REQUEST";
export const PUSH_EQUAL_SUCCESS = "PUSH_EQUAL_SUCCESS";
export const PUSH_CLEAR_BUTTON_REQUEST = "PUSH_CLEAR_BUTTON_REQUEST";
export const PUSH_CLEAR_BUTTON_SUCCESS = "PUSH_CLEAR_BUTTON_SUCCESS";